module.exports = __webpack_public_path__ + "static/fonts/iconfont.e2827e7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.eot?t=1537345898601
// module id = OzxM
// module chunks = 90